<template>
  <div class="splash">
    <div v-if="hasRound" class="splash__body">
      <div class="imageContainer">
        <img class="splash__image" src="/static/AT_RadioRing_C.jpeg" alt="Radioring"/>
        <router-link v-if="!hasSingleCategory" :to="{ name: 'home' }">
          <button class="main-button">
           Website
          </button>
        </router-link>

        <router-link
          v-if="hasSingleCategory"
          :to="urlForCategory(category)"
        >
          <button class="main-button">
            Stem nu
          </button>
        </router-link>
      </div>
    </div>

    <div v-else class="message-container">
      <b style="font-size: large;">Het is momenteel niet mogelijk om te stemmen.</b>
    </div>

    <div class="container--border p--lg" style="text-align: left; font-size: 100%;" v-if="frontend.description">
      <p v-html="frontend.description"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Splash',
  computed: {
    round() {
      return this.$store.state.rounds
    },
    frontend() {
      return this.$store.state.frontend
    },
    hasRound() {
      return typeof this.round === 'object'
    },
    categories() {
      return this.round.categories.data
    },
    category() {
      return this.categories[0]
    },
    hasSingleCategory() {
      return this.round.categories.data.length >= 1
    },
    styles() {
      return this.hasRound && this.round.image
        ? {
            backgroundImage: `url(${this.round.image})`
          }
        : {}
    }
  },
  methods: {
    urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categoryId: category.id
        }
      }
    }
  }
}
</script>

<style>
.frontend-image-span {
  display: flex;
  justify-content: center;
}

.frontend-image {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/components/Splash.vue